import {
  VirtualTable,
  type VirtualTableProps,
} from '@devexpress/dx-react-grid-material-ui';
import {styled} from '@mui/material/styles';

const StyledOptixTableContainer = styled(VirtualTable.Container)(({theme}) => ({
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
  flex: '1 !important',
  height: 'auto !important',
  minHeight: 0,
  overflow: 'auto',
}));

export function OptixTableContainer({
  ...props
}: VirtualTableProps): JSX.Element {
  return <StyledOptixTableContainer {...props} />;
}
